// app/javascript/controllers/translation_fields_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["key", "translationField"]

  connect() {
    this.updateFieldTypes()
  }

  keyChanged() {
    this.updateFieldTypes()
  }

  updateFieldTypes() {
    const isRichText = this.keyTarget.value.includes('rich_text')

    this.translationFieldTargets.forEach(fieldContainer => {
      const locale = fieldContainer.dataset.locale
      this.updateField(fieldContainer, locale, isRichText)
    })
  }

  updateField(container, locale, isRichText) {
    const currentContent = this.getFieldContent(container)

    if (isRichText) {
      container.innerHTML = this.buildRichTextField(locale, currentContent)
    } else {
      container.innerHTML = this.buildSimpleTextField(locale, currentContent)
    }
  }

  getFieldContent(container) {
    const textArea = container.querySelector('textarea')
    const trixEditor = container.querySelector('trix-editor')
    const hiddenInput = container.querySelector('input[type="hidden"]')

    if (textArea) return textArea.value
    if (trixEditor) return trixEditor.innerHTML
    if (hiddenInput) return hiddenInput.value
    return ''
  }

  buildRichTextField(locale, content = '') {
    const sanitizedContent = content.replace(/"/g, '&quot;')
    return `
      <div class="trix-content">
        <input type="hidden"
               name="static_content[rich_content_${locale}]"
               id="static_content_rich_content_${locale}"
               value="${sanitizedContent}" />
        <trix-editor class="trix-content block w-full rounded-md border-gray-300
                            dark:border-gray-600 shadow-sm focus:border-indigo-500
                            focus:ring-indigo-500 dark:bg-gray-700 dark:text-white sm:text-sm"
                     input="static_content_rich_content_${locale}">
          ${content}
        </trix-editor>
      </div>
    `
  }

  buildSimpleTextField(locale, content = '') {
    return `
      <textarea name="static_content[content_${locale}]"
                id="static_content_content_${locale}"
                rows="3"
                class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500
                       block w-full sm:text-sm border-gray-300 dark:border-gray-600
                       rounded-md dark:bg-gray-700 dark:text-white">${content}</textarea>
    `
  }
}
